/**
 * Created by mark on 11/12/2017.
 */



import React from 'react';
import { Row, Col, Card } from 'react-bootstrap'
import ApplicationServices from '../services/base-service.js';
export default class Authentication extends React.Component {
    constructor(props) {
        super();
        this.props = props;
        this.state = {
        };
    }

    componentWillMount() {
    }

    authentication() {
    }

    render() {
        return <div>
            <Row>
                <Col>
                    <br />
                    <br />
                    <Card body>
                        <br />
                        <center style={{ top: '-50px', marginLeft: '-75px', left: '50%', position: 'absolute' }}><img height="150px" src="./img/logos/languagenut/no-text-logo.png" /></center>
                        <br />
                        <br />
                        <center><h1 class="display-4" style={{ marginBottom: '10px' }}>Thank You!<br /><small><small></small></small></h1></center>
                        <br />
                        <p>Thank you for signing up for Languagenut. To get your school access to the resources we need a short call with you to set up Languagenut to align to your curriculum. Please email me on <a href="mailto:archie@languagenut.com">archie@languagenut.com</a> or <a href="https://www.languagenut.com/global/book-a-demo/?no_redirect=true">click here</a> here to schedule a meeting.</p>

                        <b>Key Features</b>
                        <br />

                        <ul class="fa-ul">
                            <li><span class="fa-li"><i class="fas fa-check"></i></span><b>Primary/Elementary, Secondary/High and EAL/ESOL</b> resources.</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>8,000 exam-style questions - reading, writing, listening and speaking</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Pre-made assignments - <b>over 300 hours of tasks ready for home learning</b></li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Resources in <b>French, Spanish, German, Mandarin + 20</b> more languages</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>2,500+ vocabulary items</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Comprehensive grammar and verb activities</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Sentence building games</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Create your own content</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Set assignment/homework</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Comprehensive reporting, tracking and feedback for your students</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Practise forming full sentences and sentence chunks</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Improve your pronunciation with our engaging phonics activities</li>
                        </ul>

                        <hr />
                        <p>
                            <center>
                                <span style={{ fontStyle: 'italic' }}>I introduced Languagenut to our school at the end of Term 1 2018 and asked the students to work on the Weather topics as a means of preparation for the Term 2 topic on Change. All students were instantly engaged as Languagenut allowed them to work with games, repetition and at their own pace. The students who usually found French challenging also enjoyed Languagenut as they were able to use it (so they thought) as just an iPad game. Overall, students have loved getting medals and seeing our school progress in ranking. It has given them another reason for doing well in French. They can’t believe they can work on Languagenut at home and call it homework!
                                <br />
                                I love being able to see their progress when I go into the Admin/Class management section and this allows me to give individual feedback and direction. I am delighted in how positively engaged the students are in Languagenut and will continue using it for other topics.
                                <br />
                                    <br />
                                Marylou Higgins
                                <br />
                                    <b>Boroondara Park Primary School, Australia</b>
                                    <br /><br />
                                My students really enjoy using Languagenut from Years 3-6 here at Boondall State School, and yes we are currently enjoying being in first position. Actually, even as I write this, I have a Year 4 class showing the Preps some of the features, so they are well prepared for when they have computer and German skills in Year 2. I have been using this program for at least 8 years and enjoy the updates. It really forms a solid base for basic and then more complicated vocabulary, allowing the students to progress at their own rate.
                                <br /><br />
                                Kristina Vlaisa
                                <br /><br />
                                    <b>Boondall State School, Australia</b></span>

                            </center>
                        </p>
                        <center>
                            <small>For any questions email <a href="mailto:archie@languagenut.com">archie@languagenut.com</a></small>
                            <br /><img height="80px" src="https://s3-eu-west-1.amazonaws.com/marketing.languagenut.com/Sales%20site/Languagenut%20Sales%20Sites%20Image%20Assets/LN%20Logo.png" />
                        </center>
                    </Card>
                </Col>
            </Row>
        </div>
    }
}